import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import { type ILayerProps, type ISize, type IVectorLayerProps } from '@/version-types';
import { checkIsUsingEffect } from './effect';
import { LayerCanvasCreator } from './layer-canvas';

export class ResultCanvasCreator {
    private layer: ILayerProps;
    private layerData: IVectorLayerProps;
    private stageSize: ISize;

    private isUsingEffect: boolean;

    constructor(
        private identity: string,
        layer: ILayerProps,
        stageSize: ISize,
    ) {
        this.layer = layer;
        this.layerData = layer.data as IVectorLayerProps;
        this.stageSize = stageSize;

        this.isUsingEffect = checkIsUsingEffect(this.layerData, {
            includeBlur: true,
        });
    }

    public async create(textResultCanvas?: HTMLCanvasElement) {
        const layerCanvasCreator = new LayerCanvasCreator(this.identity, this.layer, false);
        const layerCanvas = await layerCanvasCreator.create({ isPPT: false });

        if (!layerCanvas) return;

        const { width, height, left, top } = this.layer;

        let resultWidth = toInteger(width);
        let resultHeight = toInteger(height);

        const centerPoint = {
            x: resultWidth / 2 + left,
            y: resultHeight / 2 + top,
        };
        const drawOffsetPoint = {
            x: -resultWidth / 2,
            y: -resultHeight / 2,
        };

        if (this.isUsingEffect) {
            const { scaleWidth, scaleHeight, offsetY } = layerCanvasCreator.getEffectLayoutInfluence();
            resultWidth = layerCanvas.width;
            resultHeight = layerCanvas.height;
            drawOffsetPoint.x = -toInteger(width) / 2 - scaleWidth;
            drawOffsetPoint.y = -toInteger(height) / 2 - scaleHeight - offsetY;
        }

        const { rotate, opacity } = this.layer;
        const { width: stageWidth, height: stageHeight } = this.stageSize;
        const { canvas, ctx } = createCanvas(stageWidth, stageHeight);

        ctx.translate(centerPoint.x, centerPoint.y);
        ctx.rotate((Math.PI / 180) * rotate);
        ctx.globalAlpha = opacity;
        ctx.drawImage(
            layerCanvas,
            0,
            0,
            resultWidth,
            resultHeight,
            drawOffsetPoint.x,
            drawOffsetPoint.y,
            resultWidth,
            resultHeight,
        );

        if (!textResultCanvas) return canvas;

        const { canvas: finalCanvas, ctx: finalCtx } = createCanvas(stageWidth, stageHeight);
        finalCtx.drawImage(canvas, 0, 0);
        finalCtx.drawImage(textResultCanvas, 0, 0);

        return finalCanvas;
    }
}
